/*
 *  Author: DL
 *  Date: 2020-11-21 11:18:14
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-16 14:26:22
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */
/**
 * [orientationEvent 提供andriod,ios h5的方向传感器]
 * @param  {[function]} orientationCallback [监听方向]
 */

function updateOrientation(orientationCallback) {
    (function(exports) {
        var angle = 0;

        let timer = setInterval(function() {
            if (orientationCallback) {
                clearInterval(timer);

                // 判断IOS;
                var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

                if (!iOS) {
                    if (window.DeviceOrientationEvent) {
                        window.addEventListener('deviceorientationabsolute', function(event) {
                            angle = event.webkitCompassHeading ? event.webkitCompassHeading : event.alpha;
                            if (orientationCallback) {
                                orientationCallback(angle);
                            }
                        });
                    }
                } else {
                    //通过设备传感器更改定位标注物的方向
                    if (!!window.DeviceOrientationEvent) {
                        if (typeof DeviceOrientationEvent.requestPermission === 'function') {
                            DeviceOrientationEvent.requestPermission()
                                .then(function(response) {
                                    if (response === 'denied') {
                                        console.log('您取消了获取手机方向请求，如再次使用请清除浏览器缓存再试');
                                    } else {
                                        window.addEventListener(
                                            'deviceorientation',
                                            function(event) {
                                                // iOS设备直接使用webkitCompassHeading
                                                if (event.webkitCompassHeading) {
                                                    // 由于实际是指北的，需要反转角度，下同
                                                    angle = event.webkitCompassHeading;
                                                }

                                                if (orientationCallback) {
                                                    orientationCallback(-angle);
                                                }
                                            },
                                            true,
                                        );
                                    }
                                })
                                .catch(function(error) {
                                    console.log(error);
                                });
                        } else {
                            // non iOS 13+
                            window.addEventListener(
                                'deviceorientation',
                                function(event) {
                                    if (event.webkitCompassHeading) {
                                        angle = event.webkitCompassHeading;
                                    }

                                    if (orientationCallback) {
                                        orientationCallback(-angle);
                                    }
                                },
                                true,
                            );
                        }
                    }
                }
            } else {
            }
        }, 500);
    })(window);
}

export default updateOrientation;
